<div>
    <div *ngIf="phone">
        <h2 class="mb-5">{{title | translate}}</h2>
        <p *ngIf="phone" class="mb-0"
            [innerHTML]="subtitle | translate: {$1: this.phone.substr(this.phone.length - 4)}"></p>
        <p *ngIf="!phone || phone.length === 0" class="mb-0"
            [innerHTML]="'phone-validation-no-phone-number' | translate">
        </p>

        <form>
            <div id="otp" class="otp-group d-flex justify-content-center mx-auto mt-4 pt-3">
                <div class="opt-form">
                    <input  #otpInputHtml autofocus type="text" [(ngModel)]="inputOTP" [ngModelOptions]="{standalone: true}" autocomplete="one-time-code" maxlength="6" pattern="\d{6}" spellcheck="false" (keypress)="setInput($event)" (input)="changeInput($event)" [class.error]="isError" [class.opacity-50]="waitOtp" 
                    >
                </div>
            </div>
            <ng-container *ngIf="isError">
                <div class="error text-center pt-2"><strong>{{"phone-validation-error" | translate }}</strong></div>
            </ng-container>
        </form>

        <strong>
            <p *ngIf="phone" class="mt-5 mb-3 text-center">
                <span *ngIf="counter">{{"phone-validation-expire-time" | translate}}</span> {{counter}}
            </p>
        </strong>

        <div class="w-100 d-flex justify-content-center">
            <button *ngIf="phone" class="my-3 text-center btn btn-tertiary" (click)="sendNewOtp()" [disabled]="waitOtp">
                {{"phone-validation-button-send-new" | translate}}</button>
        </div>

    </div>

    <!-- <button class="btn btn-primary w-100 mt-auto" [disabled]="!showSend || waitOtp"
        (click)="next()">{{"phone-validation-button-confirm" | translate}} <div *ngIf="waitOtp" class="spinner-border ms-2"></div></button> -->
</div>